<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(v-model="form.code", :label="translations.label.code", :disabled="true")
          v-col(cols="12" sm="6" md="4")
            BaseFloatField(v-model="form.ggr", :label="translations.label.ggr" min="0" max="100" decimals="2")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required|host" v-model="form.icon", :label="translations.label.icon")

          //- v-col(cols="12" sm="6" md="4")
          //-   BaseTextField(rules="required" v-model="form.key", :label="translations.label.key")
          //- v-col(cols="12" sm="6" md="12" lg="12")
          //-   BaseSelectField(rules="required", :items="accountManagerList" v-model="form.am", :label="translations.label.accountManager")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Mode:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.mode.fun", :label="translations.label.fun")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.mode.real", :label="translations.label.real")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Platform:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.platform.mobile", :label="translations.label.mobile")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.platform.desktop", :label="translations.label.desktop")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Urls:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.launcher", :label="translations.label.urls.launcher")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.bonusAward", :label="translations.label.urls.bonusAward")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.bonusCancel", :label="translations.label.urls.bonusCancel")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.ping", :label="translations.label.urls.ping")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.roundDetails", :label="translations.label.urls.roundDetails")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.fixedLauncher", :label="translations.label.urls.fixedLauncher")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.baseUrl", :label="translations.label.urls.baseUrl")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.gameList", :label="translations.label.urls.gameList")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Invoice:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.name", :label="translations.label.invoice.name")
                v-col.py-0(cols="12" sm="6")
                  BaseTextAreaField(rules="required" v-model="form.invoice.address", :label="translations.label.invoice.address")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.vat", :label="translations.label.invoice.vat")
                v-col.py-0(cols="12" sm="6")
                  //- BaseFloatField(v-model="form.invoice.tax", :label="translations.label.invoice.tax", :required="true" min="0" max="100" decimals="2")
                  BaseTextField(rules="required|numeric|min_value:0" v-model="form.invoice.tax", :label="translations.label.invoice.tax")
                  //- BaseTextField(rules="required" v-model="form.invoice.tax", :label="translations.label.invoice.tax")
                v-col.py-0(cols="12" sm="6")
                  BasePhoneField(rules="required" v-model="form.invoice.phone", :label="translations.label.invoice.phone")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required|email" v-model="form.invoice.email", :label="translations.label.invoice.email")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend {{ translations.label.config.title }}:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.rst", :label="translations.label.config.rst")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.amb", :label="translations.label.config.amb")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.rnc", :label="translations.label.config.rnc")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.anr", :label="translations.label.config.anr")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.aoc", :label="translations.label.config.aoc")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.hfr", :label="translations.label.config.hfr")
        v-row(v-if="form.cfg.hfr")
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.customfields }}
                v-expansion-panel-content
                  v-divider.mb-4
                  v-switch(v-model="form.freerounds.multigame")
                    template(v-slot:label)
                      span(v-if="form.singleMultiGame")
                        | {{ translations.label.selection }}: {{ translations.label.singleGame }} | 
                        strong {{ translations.label.multiGame }}
                      span(v-else)
                        | {{ translations.label.selection }}: 
                        strong {{ translations.label.singleGame }}
                        |  | {{ translations.label.multiGame }}
                  v-switch(v-model="form.freerounds.multiUser")
                      template(v-slot:label)
                        span(v-if="form.freerounds.multiUser")
                          | {{ translations.label.selection }}: {{ translations.label.singleUser }} | 
                          strong {{ translations.label.multiUser }}
                        span(v-else)
                          | {{ translations.label.selection }}: 
                          strong {{ translations.label.singleUser }}
                          |  | {{ translations.label.multiUser }}
                  v-divider.mb-4
                  BaseFieldsGenerator(:value="form.freerounds.fields" @input="updateFreeroundsFields")
        v-row
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.buttons.edit }}
</template>

<script>

  export default {
    name: "ProviderEdit",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      provider: {
        type: Object,
        default: function(){
          return {}
        }
      },
      accountManagerList: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        code: '',
        key: '',
        am: '',
        mode: {
          fun: '',
          real: '',
        },
        platform: {
          mobile: '',
          desktop: '',
        },
        ggr: null,
        urls: {
          launcher: '',
          bonusAward: '',
          bonusCancel: '',
          ping: '',
          roundDetails: '',
          fixedLauncher: '',
          baseUrl: '',
          gameList: '',
        },
        invoice: {
          name: '',
          address: '',
          vat: '',
          tax: '',
          phone: '',
          email: '',
        },
        icon: '',
        cfg: {
          rst: false,
          amb: false,
          rnc: false,
          anr: false,
          aoc: false,
          hfr: false,
        },
        freerounds: {
          multigame: false,
          multiUser: false,
          fields: [],
        },
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editProvider.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editProvider.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200){
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          _id: this.provider._id,
          data: {
            name: this.form.name,
            code: this.form.code,
            icon: this.form.icon,
            mode: {
              fun: this.form.mode.fun,
              real: this.form.mode.real
            },
            platform: {
              desktop: this.form.platform.desktop,
              mobile: this.form.platform.mobile
            },
            urls: {
              launcher: this.form.urls.launcher,
              bonusAward: this.form.urls.bonusAward,
              bonusCancel: this.form.urls.bonusCancel,
              ping: this.form.urls.ping,
              roundDetails: this.form.urls.roundDetails,
              fixedLauncher: this.form.urls.fixedLauncher,
              baseUrl: this.form.urls.baseUrl,
              gameList: this.form.urls.gameList,
            },
            invoice: {
              name: this.form.invoice.name,
              address: this.form.invoice.address,
              vat: this.form.invoice.vat,
              tax: this.form.invoice.tax,
              phone: this.form.invoice.phone,
              email: this.form.invoice.email,
            },
            cfg: {
              rst: this.form.cfg.rst,
              amb: this.form.cfg.amb,
              rnc: this.form.cfg.rnc,
              anr: this.form.cfg.anr,
              aoc: this.form.cfg.aoc,
              cl: this.form.cfg.cl,
              hfr: this.form.cfg.hfr,
            },
            multigame: this.form.singleMultiGame,
          },
        };
        if(this.form.ggr != undefined && this.form.ggr != null && this.form.ggr != ''){
          formSend.data.ggr = parseFloat(this.form.ggr);
        }
        if (this.form.cfg.hfr){
          formSend.data['fr'] = {};
          if (this.form.freerounds.fields.length){
            formSend.data.fr['f'] = this.form.freerounds.fields;
          }
          if (this.form.freerounds.multigame){
            formSend.data.fr['mg'] = this.form.freerounds.multigame;
          }
          if (this.form.freerounds.multiUser){
            formSend.data.fr['mu'] = this.form.freerounds.multiUser;
          }
        }
        this.$store.dispatch('editProvider', formSend);
      },
      updateFreeroundsFields(newFields){
        this.form.freerounds.fields = [...newFields];
      },
      setFields(){
        this.form.name = this.provider.name;
        this.form.code = this.provider.key;
        this.form.mode.fun = this.provider.mode.fun;
        this.form.mode.real = this.provider.mode.real;
        this.form.platform.mobile = this.provider.platform.mobile;
        this.form.platform.desktop = this.provider.platform.desktop;
        this.form.ggr = this.provider.ggr;
        this.form.icon = this.provider.icon;
        this.form.urls.launcher = this.provider.urls.launcher;
        this.form.urls.bonusAward = this.provider.urls.bonusAward;
        this.form.urls.bonusCancel = this.provider.urls.bonusCancel;
        this.form.urls.ping = this.provider.urls.ping;
        this.form.urls.roundDetails = this.provider.urls.roundDetails;
        this.form.urls.fixedLauncher = this.provider.urls.fixedLauncher;
        this.form.urls.baseUrl = this.provider.urls.baseUrl;
        this.form.urls.gameList = this.provider.urls.gameList;
        this.form.invoice.name = this.provider.invoice.name;
        this.form.invoice.address = this.provider.invoice.address;
        this.form.invoice.vat = this.provider.invoice.vat;
        this.form.invoice.tax = this.provider.invoice.tax;
        this.form.invoice.phone = this.provider.invoice.phone;
        this.form.invoice.email = this.provider.invoice.email;
        this.form.cfg.rst = this.provider.cfg.rst;
        this.form.cfg.amb = this.provider.cfg.amb;
        this.form.cfg.rnc = this.provider.cfg.rnc;
        this.form.cfg.anr = this.provider.cfg.anr;
        this.form.cfg.aoc = this.provider.cfg.aoc;
        this.form.cfg.cl = this.provider.cfg.cl;
        this.form.cfg.hfr = this.provider.cfg.hfr;
        this.form.freerounds.multigame = this.provider.fr != undefined && this.provider.fr.mg !== undefined,          // TODO, pendiente confirmar que venga con este nombre
        this.form.freerounds.multiUser = this.provider.fr != undefined && this.provider.fr.mu !== undefined,          // TODO, pendiente confirmar que venga con este nombre
        this.form.freerounds.fields = this.provider.fr != undefined ? this.provider.fr.f : [];    // TODO, pendiente confirmar que venga este valor
        this.form.params = this.changeObjectToArray(this.provider.params);
        this.form.launcherParams = this.changeObjectToArray(this.provider.lp);
      },
      changeObjectToArray(objarr){
        if(objarr != undefined){
          let arr = [];
          Object.keys(objarr).forEach(keyitem=>{
            arr.push({
              key: keyitem,
              value: objarr[keyitem]
            });
          })
          return arr;
        } else {
          return [];
        }
      },
    }
  }
</script>

<style lang="sass">
</style>